module.exports = __webpack_public_path__ + "media/vue-calc.0a2fcea6.mp4";